import { logger } from '@/utils/logger/logger';
import {
  detectSectionMarkerResidue,
  type MarkerResiduePayload,
} from '@heidi/editor/core';
import { getCurrentSessionId } from '@heidi/runtime/shell';

/**
 * App-side reporter for the residue detector in `@heidi/editor/core`, which
 * owns the rules. Detection only — no behaviour change.
 *
 * A warn is a prompt to look, not proof of a stripper failure: a note body can
 * legitimately contain marker text, because Ask Heidi echoes the note back
 * when asked to reformat it. Alert on a change in rate, not on a single hit.
 */

export type MarkerResidueSurface = 'copy' | 'export' | 'print';
export type { MarkerResidueFlavor, MarkerResiduePayload } from '@heidi/editor/core';

/**
 * Emits at most one warn per copy/export operation. Identifiers and kinds
 * only — never a byte of the payload, which is note content.
 */
export const reportSectionMarkerResidue = ({
  payloads,
  surface,
  sessionId,
}: {
  payloads: readonly MarkerResiduePayload[];
  surface: MarkerResidueSurface;
  sessionId?: string;
}): void => {
  try {
    const { found, marker_kind } = detectSectionMarkerResidue(payloads);
    if (!found) return;

    logger.warn('[SECTIONS] marker residue in output', {
      surface,
      marker_kind,
      session_id: sessionId || getCurrentSessionId() || '',
    });
  } catch {
    // A tripwire must never change whether a copy or export succeeds.
  }
};
